/* Call phases used by the UI:
 *   idle        — no call
 *   dialing     — outgoing, waiting for callee to answer
 *   incoming    — incoming, showing accept/decline sheet
 *   in_call     — both sides connected, audio flowing */
export const PHASE = {
  IDLE: "idle",
  DIALING: "dialing",
  INCOMING: "incoming",
  IN_CALL: "in_call",
};
